/**
 * Base class for all platform cartridge widgets
 */
export abstract class PlatformCartridgeWidgetComponent {}
